import { useLocation, useParams } from 'react-router-dom';
import type { Params } from 'react-router-dom';

import { ReverseMappedRoutes, Routes } from 'constants/routes';

/**
 * Remove all paramaeters from the pathname as well as from the route and compares that.
 *
 * @param search current search parameters
 * @param pathname current browser location
 * @returns compare function that matches routes
 */
const createCompareRoute =
    (search: Readonly<Params>, pathname: string) => (route: string) => {
        if (route.includes(':')) {
            const emptyRoute = route.replace(/:[a-zA-Z-]*/u, '');
            let emptyPathname = pathname;
            Object.values(search).forEach(
                (ent) => (emptyPathname = emptyPathname.replace(ent ?? '', ''))
            );
            return emptyPathname === emptyRoute;
        }
        return pathname === route;
    };

/**
 * A custom hook returning current Route from Routes based on a location.
 */
export const useCurrentRoute = (): Routes => {
    const { pathname } = useLocation();
    const search = useParams();
    const currentRoute =
        Object.values(Routes).find(createCompareRoute(search, pathname)) ?? '*';

    return ReverseMappedRoutes[currentRoute] || Routes.NOT_FOUND;
};
